<template>
    <div
        id="school-makeover"
        ref="makeoverRoot"
        class="pos-relative aspect bg-default-1 border-radius overflow-hidden"
        @mouseenter="moveDragLine = true"
        @mouseleave="moveDragLine = false"
        @touchend="moveDragLine = false"
        @touchstart="moveDragLine = true"
    >
        <picture class="pos-relative">
            <source
                data-srcset="https://chico-rei.imgix.net/images/site/mudam-o-mundo/escola-antes-1920.jpg?auto=compress,format&q=65"
                media="(min-width: 768px)"
            />
            <img
                class="img-responsive lazy lazy-fade"
                data-src="https://chico-rei.imgix.net/images/site/mudam-o-mundo/escola-antes-1000.jpg?auto=compress,format&q=65"
                draggable="false"
            />
        </picture>

        <div
            :style="imageAfterWrapperStyle"
            class="pos-absolute pos-all w-full z-1 overflow-hidden"
            style="pointer-events: none"
        >
            <picture>
                <source
                    data-srcset="https://chico-rei.imgix.net/images/site/mudam-o-mundo/escola-depois-1920.jpg?auto=compress,format&q=65"
                    media="(min-width: 700px)"
                />
                <img
                    :style="imageAfterStyle"
                    class="img-responsive lazy lazy-fade"
                    data-src="https://chico-rei.imgix.net/images/site/mudam-o-mundo/escola-depois-1000.jpg?auto=compress,format&q=65"
                    draggable="false"
                    style="min-width: 1px; min-height: 1px"
                />
            </picture>
        </div>

        <div
            :style="dragLineStyle"
            class="pos-absolute h-full w-1 bg-white shadow-1 pos-center-x z-3"
        />
        <div
            :style="previousLabelStyle"
            class="pos-absolute pos-center-y bg-primary-3 text-white shadow-1 border-radius text-uppercase text-yanone z-2 text-center py-1"
            style="
                line-height: 1.3rem;
                transform: rotate(270deg) translateX(-50%);
                transform-origin: left top;
                width: 5rem;
            "
        >
            Antes
        </div>
        <div
            :style="afterLabelStyle"
            class="pos-absolute pos-center-y bg-primary-3 text-white shadow-1 border-radius text-uppercase text-yanone z-2 text-center py-1"
            style="
                line-height: 1.3rem;
                transform: rotate(270deg) translateX(-50%);
                transform-origin: left top;
                width: 5rem;
            "
        >
            Depois
        </div>
    </div>
</template>

<script>
    import { updateLazyLoad } from '../../../common/common';

    export default {
        el: '#vue-school-makeover',

        name: 'SchoolMakeover',

        data() {
            return {
                rootX: null,
                relativeMouseX: null,
                moveDragLine: false,
            };
        },

        mounted() {
            window.addEventListener('mousemove', this.onMouseMove);
            window.addEventListener('touchmove', this.onMouseMove);
            window.addEventListener('resize', this.onWindowResize);

            this.onWindowResize();

            updateLazyLoad();
        },

        beforeDestroy() {
            window.removeEventListener('mousemove', this.onMouseMove);
            window.removeEventListener('touchmove', this.onMouseMove);
            window.removeEventListener('resize', this.onWindowResize);
        },

        computed: {
            dragLineStyle() {
                return {
                    top: 0,
                    left: this.relativeMouseX !== null ? this.relativeMouseX + 'px' : '50%',
                };
            },

            previousLabelStyle() {
                return {
                    left: `calc(${
                        this.relativeMouseX !== null ? this.relativeMouseX + 'px' : '50%'
                    } - 1.8rem)`,
                };
            },

            afterLabelStyle() {
                return {
                    left: this.relativeMouseX !== null ? this.relativeMouseX + 'px' : '50%',
                };
            },

            imageAfterWrapperStyle() {
                return {
                    left: this.relativeMouseX !== null ? `${this.relativeMouseX}px` : '50%',
                };
            },

            imageAfterStyle() {
                return {
                    transform: `translateX(-${
                        this.relativeMouseX !== null ? this.relativeMouseX + 'px' : '50%'
                    })`,
                };
            },
        },

        methods: {
            onMouseMove(event) {
                if (this.moveDragLine) {
                    let x;

                    if (event.type === 'mousemove') {
                        x = event.clientX;
                    } else if (event.type === 'touchmove') {
                        x = event.touches[0].clientX;
                    }

                    this.relativeMouseX = Math.max(
                        0,
                        Math.min(this.$refs.makeoverRoot.clientWidth, x - this.rootX)
                    );
                }
            },

            onWindowResize() {
                this.relativeMouseX = null;
                this.rootX = this.$refs.makeoverRoot.getBoundingClientRect().left;
            },
        },
    };
</script>